import { useEffect, useState } from "react";

// Thin bar at the top while data loads — pages keep their last data on screen instead of flashing a spinner.
export function TopProgress() {
  const [on, setOn] = useState(false);
  useEffect(() => {
    let tm;
    const h = (e) => { clearTimeout(tm); if (e.detail > 0) tm = setTimeout(() => setOn(true), 180); else setOn(false); };
    window.addEventListener("buma:net", h);
    return () => { clearTimeout(tm); window.removeEventListener("buma:net", h); };
  }, []);
  return (
    <div aria-hidden data-testid="top-progress" data-active={on ? "1" : "0"} className={`fixed top-0 inset-x-0 h-[3px] z-[9999] pointer-events-none overflow-hidden transition-opacity duration-200 ${on ? "opacity-100" : "opacity-0"}`}>
      <div className="h-full w-1/3 bg-[#0038EB] rounded-full animate-[topprogress_1.1s_ease-in-out_infinite]" />
      <style>{"@keyframes topprogress{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}"}</style>
    </div>
  );
}
